import { Button, Divider, ModalBody, ModalFooter, Stack, Text, useToast } from "@chakra-ui/react";
import { Alert, Form, Icon, Modal } from "components";
import { API } from "config";
import { Mask } from "config";
import moment from "moment";
import { useState } from "react";

export default function ProductsSales({ ...props }){

    const toast = useToast()
    const [ loading, setLoading ] = useState()
    const [ errors, setErrors ] = useState()
    const [ init, setInit ] = useState(moment().startOf('month').format('DD/MM/Y'))
    const [ end, setEnd ] = useState(moment().endOf('month').format('DD/MM/Y'))

    const handleSubmit = async () => {
        setLoading(true)

        try{
            const callback = await API.get(`/tools/orders/products_sales?init=${init}&end=${end}`)
            toast({ title: 'Relatório gerado', description: 'Download em andamento...', status: 'success'})
            window.open(callback?.data?.download_url)
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível gerar o relatório agora. Tente novamente.', description: err?.response?.data?.message, status: 'warning'})
        }

        setLoading(false)
    }

     return(
    <Modal title="Produtos vendidos por período." {...props}>
        <ModalBody>
            <Stack spacing={4}>
                <Text fontSize="sm">O relatório será gerado para todos os pedidos aprovados no intervalo de datas definido abaixo. Será gerado um arquivo .csv e o download se iniciará em seguida.</Text>
            
                <Divider />

                <Form.Form onSubmit={handleSubmit}>
                    <Form.Text
                        required
                        label="Data de início:"
                        name="init"
                        value={init}
                        onChange={e => setInit(Mask.date(e.target.value))}
                        isDisabled={loading}
                        error={errors?.init}
                        placeholder="Ex.: 01/01/2025"
                    />

                    <Form.Text
                        required
                        label="Data final:"
                        name="end"
                        value={end}
                        onChange={e => setEnd(Mask.date(e.target.value))}
                        isDisabled={loading}
                        error={errors?.end}
                        placeholder="Ex.: 31/05/2025"
                    />

                    <Alert>É recomendável que importe este arquivo no <a href="">Planilhas do Google</a> para melhor visualização.</Alert>
                </Form.Form>
            </Stack>
        </ModalBody>

        <ModalFooter>
            <Button w="100%" colorScheme="orange" onClick={handleSubmit} isLoading={loading} loadingText="Gerando relatório..." leftIcon={<Icon name="download" />}>Gerar relatório e fazer download</Button>
        </ModalFooter>
    </Modal>
    )
}